module.exports = __webpack_public_path__ + "14bb81da985375ea9f9d65d9441852b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2102_teaser_image.jpg
// module id = 599
// module chunks = 0